import React from "react";
import "./App.css";
import "fontsource-roboto";
import { HashRouter as BrowserRouter } from "react-router-dom";

import Crcl from "./containers/Crcl/Crcl";
import CrclProvider from "./containers/Crcl/contexts/CrclProvider";

function App() {
  return (
    <BrowserRouter>
      <CrclProvider>
        <Crcl />
      </CrclProvider>
    </BrowserRouter>
  );
}

export default App;
